import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth } from '../services/auth';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

export const authInterceptorInterceptor: HttpInterceptorFn = (req, next) => {

  const _auth = inject(Auth);
  const router = inject(Router);

  const token = localStorage.getItem('token');

  const reqClone = token
    ? req.clone({
        headers: req.headers.set('Authorization', 'Bearer ' + token),
      })
    : req;

  return next(reqClone).pipe(
    catchError((error: HttpErrorResponse) => {
      if ((error.status === 401 || error.status === 403) && token) {
        _auth.setSessionExpired();
        _auth.clearAuthStorage();
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );

};